import React, { useState } from 'react';
import './addeducation.css';

const API_URL = process.env.REACT_APP_API_URL;

const AddEducation = ({ onClose, id, fetchUser }) => {
    const [isOngoing, setIsOngoing] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    const handleeducationAdd = async (event) => {
        event.preventDefault();

        // Prevent duplicate submissions
        if (isSubmitting) {
            return;
        }

        const educourse = event.target.educationcourse.value;
        const eduschool = event.target.educationschool.value;
        const startDate = event.target.startDate.value;
        const endDate = isOngoing ? null : event.target.endDate.value;
        const edudesc = event.target.educationdesc.value;

        if (!isOngoing && new Date(startDate) > new Date(endDate)) {
            setError("Start date cannot be later than end date.");
            return;
        }

        try {
            setIsSubmitting(true);
            setError('');

            const response = await fetch(`${API_URL}/myprofile/${id}/addeducation`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                    educourse,
                    eduschool,
                    startDate,
                    endDate,
                    edudesc
                })
            });
            
            if (!response.ok) {
                throw new Error('Failed to add education');
            }

            await fetchUser();
            onClose();
        } catch (error) {
            console.error("Error adding education:", error);
            setError('Failed to add education. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <div className="education-popup-container">
            <div className="education-popup">
                <button 
                    className="education-closeBtn" 
                    onClick={onClose}
                    disabled={isSubmitting}
                >
                    <i className="fa-solid fa-x" />
                </button>
                <div className="education-popupcontent">
                    <h2 className="font-normal">Add Education</h2>
                    <form className="mt-4" onSubmit={handleeducationAdd}>
                        <input 
                            type="text" 
                            className="education-forminput" 
                            name="educationcourse" 
                            placeholder="Course of Study" 
                            required 
                            disabled={isSubmitting}
                        />
                        <input 
                            type="text" 
                            className="education-forminput" 
                            name="educationschool" 
                            placeholder="School" 
                            required 
                            disabled={isSubmitting}
                        />
                        <div className="date-inputs">
                            <label htmlFor="startDate">Start Date</label>
                            <input 
                                type="date" 
                                className="education-forminput" 
                                name="startDate" 
                                placeholder="Start Date"
                                required 
                                disabled={isSubmitting}
                            />
                            {!isOngoing && (
                                <>
                                    <label htmlFor="endDate">End Date</label>
                                    <input 
                                        type="date" 
                                        className="education-forminput" 
                                        name="endDate" 
                                        placeholder="End Date"
                                        required 
                                        disabled={isSubmitting}
                                    />
                                </>
                            )}
                            <div className="ongoing-checkbox">
                                <input 
                                    type="checkbox" 
                                    id="ongoing" 
                                    checked={isOngoing}
                                    onChange={(e) => setIsOngoing(e.target.checked)}
                                    disabled={isSubmitting}
                                />
                                <label htmlFor="ongoing">Currently studying here</label>
                            </div>
                        </div>
                        {error && (
                            <p className="text-red-500 text-sm mt-2">{error}</p>
                        )}
                        <textarea 
                            className="education-forminput" 
                            name="educationdesc" 
                            placeholder="Description" 
                            required 
                            disabled={isSubmitting}
                            style={{
                                resize: 'vertical',
                                maxHeight: '15rem'
                            }}
                        />
                        <button 
                            type="submit" 
                            className="education-forminput submit-btn"
                            disabled={isSubmitting}
                            style={{ 
                                backgroundColor: isSubmitting ? '#ccc' : '#09CE78',
                                color: 'white',
                                padding: '0.6rem 0',
                                marginTop: '1rem',
                                cursor: isSubmitting ? 'not-allowed' : 'pointer'
                            }}
                        >
                            {isSubmitting ? 'Adding...' : 'Add'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddEducation;